import { FC } from 'react';

import { Box } from '@mui/material';

import { useForm } from 'react-hook-form';

import { useStores } from 'mobx/hooks/useStores';

import { useAsyncPatientSearch } from 'hooks/useAsyncPatientSearch';

import {
  FormSpecificPatientsAsyncMultiAutocomplete,
  SpecificPatientOption
} from 'components/UIkit/atoms/Dropdown/Select/FeatureSpecific/SpecificPatientsAsyncMultiAutocomplete';
import { FormModal } from 'components/UIkit/atoms/Modal/FormModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

interface AddTreatmentFormFields {
  selectedPatients: SpecificPatientOption[];
}

export const QaAddTreatmentModal: FC<Props> = ({ isOpen, onClose, onSubmit }) => {
  const { qaStore } = useStores();
  const methods = useForm<AddTreatmentFormFields>();
  const { handleSubmit } = methods;

  const { loadOptions, handleSpecificPatientsSearched, isSpecificPatientsSelectMenuOpen } =
    useAsyncPatientSearch(true);
  const addAddTreatment = (fields: AddTreatmentFormFields) => {
    qaStore.addTreatment(fields.selectedPatients.map((item) => item.emrPatientId));
    onSubmit();
  };

  return (
    <FormModal
      defaultValues={null}
      methods={methods}
      title="Add Treatment"
      isOpen={isOpen}
      confirmActions={[{ onClick: handleSubmit(addAddTreatment), text: 'Add', disabled: false }]}
      closeAction={{ onClick: onClose, disabled: false }}
    >
      <Box mb={40}>
        <FormSpecificPatientsAsyncMultiAutocomplete
          name="selectedPatients"
          loadOptions={loadOptions}
          placeholder="Search by Name, MRN, or DOB."
          openMenuOnClick={false}
          menuIsOpen={isSpecificPatientsSelectMenuOpen}
          isRequired
          onInputChange={handleSpecificPatientsSearched}
        />
      </Box>
    </FormModal>
  );
};
